import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import * as productActions from 'redux/modules/products';
import * as ficheActions from 'redux/modules/fiches';

var _ = require('underscore');

const csvParseModule = require('csv-parse');
const parse = csvParseModule.parse || csvParseModule;
import { downloadFile } from 'download-csv';


const CSV_COLS = [

  'identification_GSM',
  'localisation_adresse',
  'localisation_ville',
  'localisation_programme',
  'localisation_designation',
  'localisation_bureau',
  'caracs_constructeur',
  'caracs_yob',
  'caracs_course',
  'caracs_niveaux',
  'caracs_charge',
  'caracs_vitesse',
  'caracs_manoeuvre',
  'caracs_entrainement',
  'caracs_portescabine',
  'caracs_portespalieres',
  'identification_NUM_SERIAL',
  'identification_NUM_ASC',
  'identification_NUM_MOD',
  'identification_ID',
  'identification_BPT',
  'localisation_prestataire',
  'identification_type',
  'identification_NUM_ASC_B',
  'localisation_gestionnaire',
  'localisation_GPS',
  'localisation_CP',
  'localisation_adresse_COMP',
  'localisation_adresse_COMP2',
  'pit_master',
  'groups',
]

import { translate } from 'react-i18next';

@translate(['common'])
@connect(

  state => ({
    //fiches:state.fiches.data
    groups: state.groups.data,
    users: state.users.data,
    productExportFail: state.products.productExportFail,
    productExportSuccess: state.products.productExportSuccess,

    importingProducts: state.products.importingProducts,
    productImportFail: state.products.productImportFail,
    productImportSuccess: state.products.productImportSuccess,


  }),
  { ...productActions })

export default class ImportExport extends Component {

  constructor(props) {

    super(props);

    this.dropzoneRef = null

    this.state = {
      files: [],
      csv_errors: false,
      csv_valid: false,
      csv_dict: [],
      sitesToUpdate: [],
      sitesToCreate: [],
      rows: [],
      productsWithoutPhoneToCreate: [],

    };

    this.onDrop = this.onDrop.bind(this);

  }


  componentDidMount() {

  }

  exportCSV = () => {

    var self = this;

    this.props.exportCSV(this.props.urlParams, this.props.fiches, _.where(this.props.products, { identification_GSM: null })).then((csv) => {
      csv = csv.replace(/null/gi, '').replace(/undefined/gi, '');
      var filename = 'export_sts_products.csv';



      downloadFile(csv, "products_export.csv")

      /*
      downloadContent({
        type: "text/csv;charset=utf-8",
        filename:
          "products_export-" +
          moment().format("YYYY-MM-DD HH:mm") +
          ".csv",
        content: csv,
        //bom:"\ufeff"
      });*/




    })

  }




  render() {

    var self = this;

    const {
      products, params, fiches, cid, errors, importingProducts, productImportFail, productImportSuccess, t
    } = this.props;

    const {
      sitesToCreate, sitesToUpdate,
      csv_valid, csv_errors,
      productsWithoutPhoneToCreate,
      productsWithoutPhoneToUpdate
    } = this.state;

    const importProducts = () => {
      self.props.dispatch(
        productActions.importProducts(
          self.props.params,
          this.state.sitesToCreate,
          this.state.sitesToUpdate,
          productsWithoutPhoneToCreate,
          productsWithoutPhoneToUpdate,
          self.props.cid
        )).then(() => {
          self.props.dispatch(productActions.load(1, params)).then(() => {
            self.props.dispatch(ficheActions.load(0, params))
          })
        })
    };

    //var header =  t("importExport.import_export")
    var header =  t("importExport.export_csv")

    return (
      <Button bsSize="sm"
        bsStyle="primary"
        onClick={() => {
          this.exportCSV()

        }}
        type="button"
        value={t("main.export")}
      >
        {t("importExport.export_csv")}
      </Button>
    );
  }


  uploadCSV() {
    this.props.launchImportCSV(

      this.props.token,
      this.state.csv_dict,
      this.state.csv_columns_mapping,

      this.props.csv_update_existing).then(() => {
        alert(t("importExport.import_success"))
        this.props.actions.product.productFetchProducts(this.props.token);
        this.setState({ existingProducts: false, newProducts: false })
      })

  }


  onDrop(files) {
    var self = this;

    const {t} = this.props

    //this.props.dispatch(this.props.actions.remote.uploadCSV())
    this.setState({
      files
    });

    var reader = new FileReader();

    reader.onloadend = function (e) {
      var data = e.target.result;
      var string = data;
      var data = [];

      var parser = parse({
        trim: true, delimiter: ';', columns: (obj) => {
          return obj
        }
      });

      // Use the writable stream api
      parser.on('readable', function () {
        var record;
        while (record = parser.read()) {
          record.identification_NUM_MOD = record.identification_NUM_MOD ? parseInt(record.identification_NUM_MOD) : ''
          record.identification_NUM_SERIAL = record.identification_NUM_SERIAL//parseInt(record.identification_NUM_SERIAL)
          //record.type                      = record.type.replace(/ /g, '').replace(/"/g, '')           
          record.localisation_adresse = record.localisation_adresse
          record.identification_NUM_ASC = record.identification_NUM_ASC.replace(/"/g, '').replace(/ /g, '').replace(/"/g, '')
          record.identification_NUM_ASC_B = record.identification_NUM_ASC_B.replace(/"/g, '').replace(/ /g, '').replace(/"/g, '')
          record.pit_master = parseInt(record.pit_master)
          data.push(record);
        }
      });

      // Catch any error
      parser.on('error', function (err) {
        var csv_errors = [];
        if (err.code == "65") {
          csv_errors.push(<tr><td colSpan={2}>{err.message}</td></tr>)
        }
        /*if( err.code == 66 ){
          csv_errors.push(<tr><td colSpan={2}>{'Il y a une ou plusieurs colonnes dans le mauvais ordres ou renommées : '+err.message.join(', ')}</td></tr>)
        }*/
        //csv_errors.push(<tr><td colSpan={2}>{"Veuillez respecter les colonnes du CSV, elles doivent respecter cet ordre : " + Object.values(csv_columns_mapping).join(', ')}</td></tr>)


        self.setState({ csv_errors })
        //alert(self.props.t("Veuillez respecter les colonnes du CSV, elles doivent respecter cet ordre : ") + Object.values(csv_columns_mapping).join(', '))             
      });
      // When we are done, test that the parsed output matched what expected

      var gen_error_txt = (index, value, err) => {
        value = value ? <span>({t("importExport.error_entry") + ' : ' + value})</span> : ''
        return <tr><td>{t("main.line")} : {(parseInt(index) + 3)}</td><td>{err} {value}</td></tr>
      }


      parser.on('finish', function () {

        var productsWithoutPhoneToCreate = [];
        var productsWithoutPhoneToUpdate = [];


        var csv_errors = [];

        var rows = data.sort(orderByProperty('identification_GSM', 'identification_NUM_MOD'));

        var duplicates = [];
        var productsToCreate = [];
        var productsToUpdate = [];

        var sitesToCreate = [];
        var sitesToUpdate = [];

        rows = _.mapObject(_.groupBy(rows, 'identification_GSM'), clist => clist.map(product => _.omit(product, 'identification_GSM')));

        _.each(rows, (products, gsm) => {
          if (gsm != "") {
            if (checkDuplicateInObject('identification_NUM_MOD', products)) {
              csv_errors.push(
                t("importExport.dup_module_for_num")
                + gsm
              )
            }
          }

        });

        //On extrait les produits sans téléphones
        var productsWithoutPhone = _.pick(rows, '');
        delete rows[''];


        _.each(productsWithoutPhone[''], (p) => {

          if (p.identification_NUM_MOD == '' || !p.identification_NUM_MOD) {
            csv_errors.push(
              `${t("importExport.no_module_defined")} ${p.num_asc}, GSM : ${gsm}`
            )
          }

          //Verifier si il existe dejà dans la base                        
          if (_.where(self.props.products, { identification_NUM_ASC: p.identification_NUM_ASC }).length > 0) {
            productsWithoutPhoneToUpdate.push(p)
          } else {
            productsWithoutPhoneToCreate.push(p)
          }

        });


        _.each(rows, (products, gsm) => {

          if (/^\+(?:[0-9]){6,14}[0-9]$/gi.test(gsm) == false) {
            csv_errors.push(
              t("importExport.international_format_req") +' '+ gsm
            )
          }

          //Verification des conflits de serials                  
          var module1 = _.where(products, { identification_NUM_MOD: 1 })

          if (module1.length > 0) {
            module1 = module1[0];

            /*
            //Verifier que les produits ont tous le meme serial que le module 1           
            if( products.filter((p)=>p.identification_type!='PIT').filter((p)=>parseInt(p.identification_NUM_SERIAL) != parseInt(module1.identification_NUM_SERIAL)).length > 0 ) {
              csv_errors.push(`Attention les produits du GSM ${gsm} n'ont pas le même serial`)
            }*/

            var serial = module1.identification_NUM_SERIAL;

            //Verifier si ce serial est dans la base                    
            var checkSiteSerial = _.where(self.props.fiches, { identification_NUM_SERIAL: serial })

            if (checkSiteSerial.length > 0) {
              //Ce serial est dans la base
              if (checkSiteSerial[0].gsm != gsm) {
                //Le numéro GSM a changé, c'est une erreur               
                csv_errors.push(
                  t("importExport.warning_serial_exists", {serial, gsm1:checkSiteSerial[0].gsm, gsm2:gsm})
                )
              }
            }

          } else {
            //ERREUR pas de module 1           
            csv_errors.push(t("importExport.no_mod_for_gsm") + gsm)
          }

          var modToDel = []
          var productsWithPit = []

          //Trier les produits avec et sans fosse
          _.each(products, (p, index) => {

            if (p.identification_NUM_MOD == '' || !p.identification_NUM_MOD) {
              csv_errors.push(` ${t("importExport.no_mod_for_product")} ${p.num_asc}, GSM : ${gsm}`)
            }

            if (p.identification_type == 'PIT') {
              //Recuperer le module master
              var master = _.where(products, { identification_NUM_MOD: p.pit_master });

              if (master.length > 0) {
                master = master[0]

                modToDel.push(master.identification_NUM_MOD)

                productsWithPit.push({ master, pit: p })

                //site.products = site.products.filter((p)=>(p.module != p.pit_master && p.module!=p.module))               
              }
            }

          });


          var productsWithoutPit = products.filter((p) => {
            if (p.identification_type == 'PIT') {
              return false
            } else {
              return modToDel.indexOf(p.identification_NUM_MOD) == -1
            }
          })

          var sites = _.where(self.props.fiches, { gsm });

          if (sites.length > 0) {

            var site = sites[0];

            var groups = []
            //var users  = []

            _.each(products, (p) => {

              //Pour chaque produits il faut vérifier que son identité et module ne sont pas changé dans le CSV, sinon conflits

              if (p.identification_NUM_MOD) {
                if (/^[1-8]{1}$/gi.test(p.identification_NUM_MOD) == false) {
                  csv_errors.push(t("importExport.mod_1_8"));
                }
              }

              //Récupérer le PID du produit dans la base pour faciliter la mise à jour             
              //Tester si le module existe dans la base

              var checkModule = _.where(site.products, { identification_NUM_MOD: p.identification_NUM_MOD });


              if (checkModule.length > 0) {

                //Ce module existe dans le site

                var bddProduct = checkModule[0];


                if (bddProduct.identification_ID != p.identification_ID) {
                  csv_errors.push(t("importExport.id_conflict_bdd_csv", {id1:bddProduct.identification_ID, id2:p.identification_ID}))
                }


                //Maintenant vérifier si son num asc et serial sont les mêmes               
                if (bddProduct.identification_NUM_ASC == p.identification_NUM_ASC && bddProduct.identification_NUM_SERIAL == p.identification_NUM_SERIAL) {
                  //ON met à jour le produit
                  p['id'] = bddProduct.id;

                } else {           

                }

              } else {
                //Si le module n'existe pas il faut rajouter le produit dans la base
                p['p_id'] = null;
              }


              var productsWithoutPhoneToCreate, productsWithoutPhoneToUpdate = [];


              var glist = p.groups.split(',').map(s => s.trim())
              //var userList = p.users.split(',').map(s=>s.trim())

              if (glist && glist.length > 0) {
                groups = groups.concat(glist)
              }

            })

            groups = _.uniq(groups);
            groups = genGroups(products, self.props.groups, groups)

            var glist = p.groups.split(',').map(s => s.trim())
            //var userList = p.users.split(',').map(s=>s.trim())

            if (glist && glist.length > 0) {
              groups = groups.concat(glist)
            }

            groups = _.uniq(groups);
            groups = genGroups(products, self.props.groups, groups)

            users = _.uniq(users);
            users = genUsers(products, self.props.users, users)

            if (users.error == true) {
              csv_errors.push(`${t("importExport.users_not_exists")} ${users.users.join(', ')}`)
            } else {
              users = users.users
            }
            //Ce numéro n'existe pas donc, on doit créer un site           
            sitesToCreate.push({
              gsm,
              productsWithoutPit,
              productsWithPit,
              groups,
              products,
              //users
            })
          }
        });

        if (csv_errors.length == 0) {
          self.setState({
            csv_valid: true, csv_dict: rows, sitesToCreate, sitesToUpdate,
            productsWithoutPhoneToCreate, productsWithoutPhoneToUpdate
          });

        } else {
          self.setState({ csv_valid: false, csv_dict: rows, csv_errors });
        }
      });

      parser.write(string);
      parser.end();

      return;
    };

    reader.readAsText(files[0], 'UTF-8');

  }




}


function orderByProperty(prop) {
  var args = Array.prototype.slice.call(arguments, 1);
  return function (a, b) {
    var equality = a[prop] - b[prop];
    if (equality === 0 && arguments.length > 1) {
      return orderByProperty.apply(null, args)(a, b);
    }
    return equality;
  };
}


function checkDuplicateInObject(propertyName, inputArray) {
  var seenDuplicate = false,
    testObject = {};

  inputArray.map(function (item) {
    var itemPropertyName = item[propertyName];
    if (itemPropertyName in testObject) {
      testObject[itemPropertyName].duplicate = true;
      item.duplicate = true;
      seenDuplicate = true;
    }
    else {
      testObject[itemPropertyName] = item;
      delete item.duplicate;
    }
  });

  return seenDuplicate;
}


function genGroups(products, bbdGroups, csv_groups) {
  var groups = [];
  if (csv_groups.length > 0) {
    csv_groups.map((g) => {
      var exists = _.where(bbdGroups, { name: g });
      if (exists.length > 0) {
        groups.push({ exists: true, g_id: exists[0].id, name: g })
      } else {
        groups.push({ exists: false, name: g })
      }
    })
    return groups;
  }
}

function genUsers(products, bbdUsers, csv_users) {
  var users = [];
  var users_not_exist = []
  var error = false;
  if (csv_users.length > 0) {
    csv_users.map((u) => {
      var exists = _.where(bbdUsers, { login: u });
      if (exists.length > 0) {
        users.push({ exists: true, id: exists[0].id, login: u })
      } else {
        users_not_exist.push(u)
        error = true
      }
    })

    if (error) {
      return { error: true, users: users_not_exist }
    } else {
      return { error: false, users }
    }

  } else {
    return { error: false, users }
  }
}



function downloadContent(options) {
  if (!options || !options.content) {
    throw "You have at least to provide content to download";
  }
  options.filename = options.filename;
  options.type = options.type || "text/plain;charset=utf-8";
  options.bom = options.bom || decodeURIComponent("%ef%bb%bf");

  if (window.navigator.msSaveBlob) {
    var blob = new Blob([options.bom + options.content], {
      type: options.type
    });
    window.navigator.msSaveBlob(blob, options.filename);
  } else {
    var link = document.createElement("a");
    var content = options.bom + options.content;
    var uriScheme = ["data:", options.type, ","].join("");
    link.href = uriScheme + content;
    link.download = options.filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
